var _defs, _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.25 153.43"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "organization-indicator_svg__a",
    x1: 147.68,
    y1: 128.12,
    x2: -4.46,
    y2: 135.49,
    gradientTransform: "matrix(1 0 0 -1 0 170)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#660f33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc1e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "organization-indicator_svg__b",
    x1: 142.24,
    y1: 102.22,
    x2: 139.84,
    y2: 61.01,
    gradientTransform: "matrix(1 0 0 -1 0 170)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48b2b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06fc9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "organization-indicator_svg__c",
    x1: 79.07,
    y1: 18.59,
    x2: 132.41,
    y2: 67.87,
    gradientTransform: "matrix(1 0 0 -1 0 170)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d12d5f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "organization-indicator_svg__d",
    x1: -17.81,
    y1: 95.62,
    x2: 76.91,
    y2: 9.85,
    gradientTransform: "matrix(1 0 0 -1 0 170)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08ed95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2b7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142 74.11a74.42 74.42 0 00-28.4-60.44",
    fill: "none",
    strokeWidth: 15,
    stroke: "url(#organization-indicator_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.21 109.2c6.14-14.25 8.77-25.38 9-41.29",
    fill: "none",
    strokeWidth: 16,
    stroke: "url(#organization-indicator_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.31 144.73c12.2.12 23.78-3.63 34.42-9.61 11.64-7.59 17.71-12.66 28.34-30.37",
    fill: "none",
    strokeWidth: 8,
    stroke: "url(#organization-indicator_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.84 137.67a74.47 74.47 0 0044.46 7.54",
    fill: "none",
    strokeWidth: 15,
    stroke: "url(#organization-indicator_svg__d)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.85,
    cy: 70.85,
    r: 70.85,
    fill: "none"
  })));
}
export default SvgOrganizationIndicator;